import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { AiOutlineDelete, AiOutlineSearch } from "react-icons/ai";
import * as moment from 'moment';
import axioPath from '../../../../../api/axioPath';
import Spinner from '../../../../components/Spinner'
import { Table } from 'reactstrap';
import Pagination from '@material-ui/lab/Pagination';
import { addminPromoCodeList } from '../../../../../redux/actions/admin';
import { SearchWrapper } from '../DashBoard/dashBoardStyled'

import Button from 'web/components/Button';

import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import { Heading, TableWrapper } from 'web/pages/private/Admin/adminStyled'

const UsersPromoCodeList = ({ togglePage, fetchMyAPI, apiData, promoUsersTableData }) => {
    let dispatch = useDispatch()
    const loaderVisible = useSelector(state => state.appReducer.loaderVisible);
    const adminRoles = useSelector(state => state.admin.adminRoles)
    const [dataList, setDataList] = useState([])
    const [finalData, setFinalData] = useState([])
    const [tableSearch, setTableSearch] = useState('')
    const [page, setPage] = useState(1);
    const [pageCount, setPageCount] = useState(0);
    const [searchDataList, setSearchDataList] = useState([]);
    const [modal, setModal] = useState(false);
    const [modalMessage, setModalMessaage] = useState('')

    let headerArr = [
        { title: 'Promo Codes', },
        { title: 'Used On ', },
        { title: 'Code Type', },
        { title: 'Type of Benefit', },
        { title: 'Status', }
    ];

    const handleChange = (event, value) => {
        setPage(value);
        let dataListtemp = JSON.parse(JSON.stringify(searchDataList))
        let pageData = JSON.parse(JSON.stringify(dataListtemp))
        setFinalData(pageData.splice(value * 10 - 10, 10))
    };

    useEffect(() => {
        initialDataSet();
    }, []);

    const initialDataSet = () => {
        if (apiData.length > 0) {
            setDataList(apiData)
            setSearchDataList(apiData)
            let pageData = JSON.parse(JSON.stringify(apiData))
            setFinalData(pageData.splice(page * 10 - 10, 10))
            if (apiData.length % 10 === 0) {
                setPageCount(apiData.length / 10)
            } else {
                setPageCount(Math.trunc(apiData.length / 10) + 1)
            }
            setTableSearch('')
        }
    };

    const handleSearchChange = e => {
        e.preventDefault()
        setTableSearch(e.target.value)
        const search = e.target.value
        let dataListtemp = dataList.filter(value => {
            return (
                (value.promoCode !== null && value.promoCode.toString().toLowerCase().includes(search.toLowerCase())) ||
                (value.state !== null && value.state.toString().toLowerCase().includes(search.toLowerCase())) ||
                (value.startDate !== null && value.startDate.toString().toLowerCase().includes(search.toLowerCase())) ||
                (value.expireDate !== null && value.expireDate.toString().toLowerCase().includes(search.toLowerCase())) ||
                (value.discountType !== null && value.discountType.toString().toLowerCase().includes(search.toLowerCase())) ||
                (value.customerElgibility !== null && value.customerElgibility.toString().toLowerCase().includes(search.toLowerCase()))
            )
        }
        );
        setPage(1)
        if (dataListtemp.length % 10 === 0) {
            setPageCount(dataListtemp.length / 10)
        } else {
            setPageCount(Math.trunc(dataListtemp.length / 10) + 1)
        }
        let tempSearchData = JSON.parse(JSON.stringify(dataListtemp))
        setSearchDataList(tempSearchData)
        setFinalData(dataListtemp.splice(0, 10))
    }

    const handleToggle = () => {
        setModal(!modal);
    }

    return (
        <>
            <TableWrapper>
                {loaderVisible && <Spinner />}
                <Heading>
                    <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                        <h3>{promoUsersTableData && promoUsersTableData[0].users} ({apiData.length} Promotion Codes Applicable)</h3>
                        <button
                            style={{ backgroundColor: '#0C7EAF', color: 'white', border: 0, borderRadius: '5px', padding: '5px 15px', margin: '5px' }}
                            onClick={() => {
                                localStorage.setItem("selectedCustomerID", apiData.length > 0 && apiData[0].userEmailID)
                                localStorage.setItem("selectedUserID", promoUsersTableData.length > 0 && promoUsersTableData[0].userId)
                                togglePage('AddPromoCodeforUser')
                            }
                            }
                        >Add New Promo Code
                        </button>
                    </div>
                </Heading>
                <Table responsive>
                    <thead>
                        <tr>
                            {headerArr.map((items, index) => (
                                <th key={index}>{items.title}</th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {
                            finalData.map((items, index) => (
                                <tr key={index}>
                                    <td>{items.promoCodesUsed}</td>
                                    <td>{moment(items.usedOn).format("MM/DD/YYYY")}</td>
                                    <td>Subscription</td>
                                    <td>{items.typeofBenefit}</td>
                                    <td>{items.isActive ? 'Active' : 'Inactive'}</td>
                                </tr>
                            ))}
                    </tbody>
                </Table>
                {finalData.length === 0 &&
                    <p style={{ position: 'absolute', width: '100%', textAlign: 'center' }}>No records found</p>
                }
                {finalData.length != 0 && dataList.length !== 0 && <Pagination count={pageCount}
                    page={page}
                    onChange={handleChange} />}
            </TableWrapper>
            <Button
                type='app-green-button submitBtn'
                handleClick={() => togglePage('UsersList')}
            >
                Back
            </Button>
        </>

    )
};

export default UsersPromoCodeList;